import { render, staticRenderFns } from "./lang-select.vue?vue&type=template&id=0ff62df4&scoped=true&"
import script from "./lang-select.vue?vue&type=script&lang=ts&"
export * from "./lang-select.vue?vue&type=script&lang=ts&"
import style0 from "./lang-select.vue?vue&type=style&index=0&id=0ff62df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff62df4",
  null
  
)

export default component.exports